<template>
  <div class="bg-app">
    <div class="container mx-auto">
      <div class="my-1 mt-8">
        <h1 class="uppercase text-3xl">Seleziona la strategia di conteggio</h1>

        <div class="flex mt-8">
          <div class="w-1/2">
            <button class="float-none sm:float-right md:float-right p-2">
              <img
                src="../assets/images/sistema-hi-lo.svg"
                alt="sistema hi-lo"
                style="width: 100%; height: auto"
                data-action="h"
              />
            </button>
          </div>
          <div class="w-1/2">
            <button class="float-none sm:float-left md:float-left p-2">
              <img
                src="../assets/images/sistema-ko.svg"
                alt="sistema ko"
                style="width: 100%; height: auto"
                data-action="k"
              />
            </button>
          </div>
        </div>
      </div>

     <div class="grid grid-cols-1 mt-2">
        <div
          class="m-auto text-center w-auto inline-block mt-2 pb-2 border-b-2 border-white border-dashed"
        >
         <a href="https://www.casino2k.com/" target="_blank">
           <img
            src="../assets/images/logo.png"
            style="width: 100px; height: auto"
          />
         </a>
        </div>
        <div class="m-auto text-center w-auto inline-block pt-4">
          <a href="https://www.casino2k.com/giochi/blackjack/strategie/contare-le-carte" target="_blank"
            class="btn bg-red-700 hover:bg-red-600 text-white font-bold py-2 px-4 rounded uppercase mt-2"
          >
            Approfondisci
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";

export default {
  name: "CounterSlector",
  store,
  data() {
    return {
      game: store.state.game,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CounterSelector.vue